import Axios from 'axios';

// Get CSRFToken for header in API call to db
Axios.defaults.xsrfCookieName = 'csrftoken';
Axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export default class PaymentIntentService {
  baseUrl = '/api/v3/pressrelease-checkout';

  paymentIntentEndpoint = 'paymentintent';

  noChargeEndpoint = 'activate-nocharge';

  constructor(checkoutToken) {
    this.checkoutToken = checkoutToken;
  }

  async createPaymentIntent() {
    const url = `${this.baseUrl}/${this.checkoutToken}/${this.paymentIntentEndpoint}/`;
    const response = await Axios.post(url);
    return response;
  }

  async updatePaymentIntent(data = {}) {
    const url = `${this.baseUrl}/${this.checkoutToken}/${this.paymentIntentEndpoint}/`;
    const response = await Axios.patch(url, data);
    return response;
  }

  async activatePressReleaseNoCharge(data = {}) {
    const url = `${this.baseUrl}/${this.checkoutToken}/${this.noChargeEndpoint}/`;
    const response = await Axios.post(url, data);
    return response;
  }
}
